import { TbPointFilled } from "react-icons/tb";
import { useStores } from "../../store/index";
import { useObserver } from "mobx-react";

const Expertise = () => {

    const { ResumeStore } = useStores();

    return useObserver(() => (
        <div className="  flex flex-col items-center justify-center  w-[80%] mx-auto my-5 md:mt-8 lg:mt-10">
            {ResumeStore.resumeBuilder.skills.length > 0 && <h1 id="skills" className="blackh1 ">Skills</h1>}
            <div className="flex text-white flex-col items-start my-2 md:my-5 gap-1 w-[70%] mx-auto text-sm lg:text-xl">
                {ResumeStore.resumeBuilder.skills.map((item, index) => (
                    <div className="flex  items-center" key={index}>
                        <TbPointFilled className="mr-1" />
                        <p className="max-w-[90%] break-words">{item.toString()}</p>
                    </div>
                ))}




            </div>
        </div>
    ));
}

export default Expertise;




